<template>
    <v-menu offset-y :close-on-content-click="true" ref="menuMain">
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
                <span>Más opciones</span>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon small>mdi-cog</v-icon>
                    </v-btn>
                </template>
            </v-tooltip>
        </template>

        <v-list dense>

            <v-list-item link @click="getItem(paramsGet, index)" v-if="getItem">
                <v-list-item-title>
                    <v-icon color="warning" left dense> mdi-pencil </v-icon> Editar
                </v-list-item-title>
            </v-list-item>
            <v-list-item link v-if="deleteItem">
                <v-list-item-title>

                    <v-menu offset-x bottom left :close-on-content-click="true" rounded="lg">
                        <template v-slot:activator="{ on: menuDelete, attrs }">
                            <span v-bind="attrs" v-on="{ ...menuDelete }">
                                <v-icon color="red" left dense> mdi-delete </v-icon> Eliminar
                            </span>
                        </template>
                        <v-card>
                            <v-list color="grey lighten-3">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <small> ¿Desea <strong>eliminar</strong> el registro actual? </small>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                            <v-card-actions class="justify-center">
                                <v-btn color="red" type="button" small text @click="$refs.menuMain.isActive = false;">
                                    Cancelar
                                </v-btn>
                                <v-divider vertical></v-divider>
                                <v-btn color="primary" type="button" small text
                                    @click="deleteItem(paramsDelete, index); $refs.menuMain.isActive = false;">
                                    Sí, eliminar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="updateStatus(paramsUpdateStatus, index)" v-if="updateStatus">
                <v-list-item-title v-if="paramsUpdateStatus.status == 0">
                    <v-icon color="success" left dense> mdi-check-circle-outline </v-icon> Activar
                </v-list-item-title>
                <v-list-item-title v-if="paramsUpdateStatus.status == 1">
                    <v-icon color="red" left dense> mdi-eye-off-outline </v-icon> Desactivar
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "MenuCrud",
    props: {
        getItem: Function,
        deleteItem: Function,
        updateStatus: Function,
        paramsGet: Object,
        paramsDelete: Object,
        paramsUpdateStatus: Object,
        index: Number
    },
    data() {
        return {
        }
    },
};
</script>
